import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { PaymentMethodsEnum } from "../enums/customer-dashboard.enum";

@Injectable({
  providedIn: "root",
})
export class CheckoutService {
  public plans = {
    payMonthly: "PAY MONTHLY",
    payAnnually: "PAY ANNUALLY",
    payFor3Years: "PAY FOR 3 YEARS",
  };

  public displaySignatureOffer = {
    displayTwoYearlyPrice: "displayTwoYearlyPrice",
    displayThreeYearlyPrice: "displayThreeYearlyPrice",
    displayFourYearlyPrice: "displayFourYearlyPrice",
    displayFiveYearlyPrice: "displayFiveYearlyPrice",
  }; 

  public displaySignatureDuration = {
    displayTwoYearlyPrice: "displayTwoYearlyPrice",
    displayThreeYearlyPrice: "displayThreeYearlyPrice",
    displayFourYearlyPrice: "displayFourYearlyPrice",
    displayFiveYearlyPrice: "displayFiveYearlyPrice",
  };

  public discountedSignatureDuration = {
    displayTwoYearlyPrice: "discountedTwoYearlyPrice",
    displayThreeYearlyPrice: "discountedThreeYearlyPrice",
    displayFourYearlyPrice: "discountedFourYearlyPrice",
    displayFiveYearlyPrice: "discountedFiveYearlyPrice",
  };

  public freeMonthsignatureDuration = {
    displayMonthlyPrice: "monthlyFreeMonth",
    displayYearlyPrice: "annuallyFreeMonth",
    displayTwoYearlyPrice: "twoYearsFreeMonth",
    displayThreeYearlyPrice: "threeYearsFreeMonth",
    displayFourYearlyPrice: "fourYearsFreeMonth",
    displayFiveYearlyPrice: "fiveYearsFreeMonth",
  };

  public signaturePlanYears = {
    displayTwoYearlyPrice: "2 years",
    displayThreeYearlyPrice: "3 years",
    displayFourYearlyPrice: "4 years",
    displayFiveYearlyPrice: "5 years",
  };

  public signaturePlanPayload = {
    displayTwoYearlyPrice: "2 Years",
    displayThreeYearlyPrice: "3 Years",
    displayFourYearlyPrice: "4 Years",
    displayFiveYearlyPrice: "5 Years",
  };

  public maximumDiscount = {
    displayMonthlyPrice: "monthlyMaximumDiscount",
    displayYearlyPrice: "yearlyMaximumDiscount",
    displayTwoYearlyPrice: "twoYearsMaximumDiscount",
    displayThreeYearlyPrice: "threeYearsMaximumDiscount",
    displayFourYearlyPrice: "fourYearsMaximumDiscount",
    displayFiveYearlyPrice: "fiveYearsMaximumDiscount",
  };

  public signaturePlanInNumber = {
    displayTwoYearlyPrice: 2,
    displayThreeYearlyPrice: 3,
    displayFourYearlyPrice: 4,
    displayFiveYearlyPrice: 5,
  };
  public intallmentLimit = {
    annuallyPlanInstallmentLimit: "annuallyPlanInstallmentLimit",
    displayTwoYearlyPrice: "twoYearsPlanIInstallmentLimit",
    displayThreeYearlyPrice: "threeYearsPlanIInstallmentLimit",
    displayFourYearlyPrice: "fourYearsPlanIInstallmentLimit",
    displayFiveYearlyPrice: "fiveYearsPlanIInstallmentLimit",
  };
  constructor() {}

  getSignaturePlanYears(text) {
    return this.signaturePlanYears[text];
  }

  getMaximumDiscount(planForm, selectedPlanPrice) {
    const text = planForm.value.planType;
    if (text === this.plans.payMonthly) {
      return selectedPlanPrice[this.maximumDiscount.displayMonthlyPrice];
    }
    if (text === this.plans.payAnnually) {
      return selectedPlanPrice[this.maximumDiscount.displayYearlyPrice];
    }

    if (text === this.plans.payFor3Years) {
      const signatureText = planForm.value.signaturePlan;
      return selectedPlanPrice[this.maximumDiscount[signatureText]];
    }
    return 0;
  }

  getSignaturePlanPaload(text) {
    return this.signaturePlanPayload[text];
  }

  getSignaturePlanInNumber(text) {
    return this.signaturePlanInNumber[text];
  }
  getSignatureDisplayPrice(item, planForm) {
    if (!item) return "";
    const text = planForm.value.signaturePlan;
    return item[this.displaySignatureOffer[text]];
  }

  getSignaturediscountedPrice(item, planForm) {
    if (!item) return 0;
    const text = planForm.value.signaturePlan;
    return item[this.discountedSignatureDuration[text]];
  }

  getSignaturePlanText(planForm) {
    return this.getSignaturePlanYears(planForm?.value?.signaturePlan);
  }

  getStandardPrice(showOnlyTotalCost, standardPrice, planForm) {
    const text = planForm.value.signaturePlan;
    const returnValue = showOnlyTotalCost
      ? `${(
          Number(standardPrice) * this.signaturePlanInNumber[text] || 0
        ).toFixed(2)}`
      : `${(
          Number(standardPrice) * this.signaturePlanInNumber[text] || 0
        ).toFixed(2)} for ${this.signaturePlanYears[text]}`;
    return returnValue;
  }

  getSignatureTotalSavingsPrice(selectedPlanPrice, planForm) {
    if (!selectedPlanPrice) return 0;
    const text = planForm.value.signaturePlan;
    return (
      selectedPlanPrice[this.displaySignatureDuration[text]] -
      selectedPlanPrice[this.discountedSignatureDuration[text]]
    );
  }

  getSignatureFreeMonths(selectedPlanPrice, planForm) {
    if (!selectedPlanPrice) return "0";
    const text = planForm.value.signaturePlan;

    return selectedPlanPrice[this.freeMonthsignatureDuration[text]];
  }
  getInstallmentPaymentPrice(
    installmentForm: FormGroup,
    subTotalWithDiscounts: any,
    showEscrowCard: boolean,
    escrowDetailsForm: FormGroup
  ) {
    let selectedMonth =
      Number(installmentForm.get("installmentType").value) - 1;
    let initialPayment =
      Number(installmentForm.get("initialInstallmentPayment").value) || 0;
    let closingAmount =
      Number(escrowDetailsForm.get("closingAmount")?.value) || 0;
    let todayPayment = Number(
      (showEscrowCard ? closingAmount : subTotalWithDiscounts) - initialPayment
    );
    let amoundividedByMonth = (todayPayment / selectedMonth).toFixed(2);
    let equalInstallment = Number(amoundividedByMonth) * (selectedMonth - 1);
    let lastInstallment = (todayPayment - equalInstallment).toFixed(2);
    return {
      amoundividedByMonth: Number(amoundividedByMonth),
      lastInstallment: Number(lastInstallment),
    };
  }

  findInstallmentLimits(planForm: FormGroup, installmentLimits: any) {
    const text = planForm.value.planType;
    if (text === this.plans.payAnnually) {
      return installmentLimits[
        this.intallmentLimit.annuallyPlanInstallmentLimit
      ];
    }

    if (text === this.plans.payFor3Years) {
      const signatureText = planForm.value.signaturePlan;
      return installmentLimits[this.intallmentLimit[signatureText]];
    }
    return 0;
  }

  getSelectedPaymentMethod(paymentValue: number) {
    if (paymentValue === PaymentMethodsEnum.card) return "credit-debit-card";
    if (paymentValue === PaymentMethodsEnum.escrow) return "escrow-invoice";
    if (paymentValue === PaymentMethodsEnum.check) return "check-payment";
    if (paymentValue === PaymentMethodsEnum.bank) return "bank-payment";
    return null;
  }
}
